import styled from "styled-components";
import { black } from "../styles/colors";
import { StoreBadges } from "./StoreBadges";

export function Nav() {
  return (
    <Bar>
      <Inner>
        <Brand href="#top">
          <LogoMark>
            <img src="/icon.svg" alt="" width={22} height={28} />
          </LogoMark>
          <LogoText>Progress</LogoText>
        </Brand>
        <Links>
          <NavLink href="#features">Features</NavLink>
          <NavLink href="#how-it-works">How it works</NavLink>
          <NavLink href="#pricing">Pricing</NavLink>
          <DesktopBadges>
            <StoreBadges />
          </DesktopBadges>
        </Links>
      </Inner>
    </Bar>
  );
}

const Bar = styled.nav({
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  zIndex: 100,
  background: "rgba(253, 253, 253, 0.88)",
  backdropFilter: "blur(12px)",
  borderBottom: "1px solid rgba(35, 35, 35, 0.06)",
});

const Inner = styled.div({
  maxWidth: 1200,
  margin: "0 auto",
  padding: "14px 24px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 24,
});

const Brand = styled.a({
  display: "flex",
  alignItems: "center",
  gap: 10,
  color: black,
});

const LogoMark = styled.div({
  display: "flex",
  alignItems: "center",
});

const LogoText = styled.span({
  fontSize: 18,
  fontWeight: 700,
  letterSpacing: "-0.02em",
});

const Links = styled.div({
  display: "flex",
  alignItems: "center",
  gap: 28,
});

const NavLink = styled.a({
  fontSize: 14,
  fontWeight: 600,
  color: black,
  opacity: 0.72,
  transition: "opacity 0.2s ease",

  "&:hover": {
    opacity: 1,
  },

  "@media (max-width: 900px)": {
    display: "none",
  },
});

const DesktopBadges = styled.div({
  transform: "scale(0.72)",
  transformOrigin: "right center",

  "@media (max-width: 900px)": {
    display: "none",
  },
});
